module.exports = __webpack_public_path__ + "07ac12477485153d4bb2aec62ec4bdb8.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=410!./images/head/RamonaRamon_in_Athen.jpg
// module id = 481
// module chunks = 0